var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',{attrs:{"title":_vm.title},on:{"remove":function($event){return _vm.$emit('remove')}}},[_c('i',[_vm._v("Динамически подставляемое значение")])])
}
var staticRenderFns = []

export { render, staticRenderFns }